import { getRegionCode, getLangCode } from "./helpers";
import type { tags } from "~/types";

type ItemWithTags = { tags?: Partial<tags> };

/**
 * Default region class. Contain region specific functions
 */
class DefaultRegion {
	/**
	 *
	 * @param _item
	 * @returns string Empty string
	 */
	static getAddress(_item: ItemWithTags): string {
		return "";
	}
}

/**
 * Region class for Romania. Contain region specific functions overies
 */

class RomanRegionOverrides extends DefaultRegion {
	/**
	 * Get address from job object
	 *
	 * @param item job object
	 */
	static getAddress(item: ItemWithTags): string {
		if (item.tags?.office_location?.data?.[0]?.name?.[getLangCode()] !== undefined) {
			return item.tags.office_location.data[0].name[getLangCode()];
		}
		return "";
	}
}

/**
 * Get region specific function class
 * @returns DefaultRegion | RomanRegionOverrides
 */
export function useRegionOverrides() {
	if (getRegionCode() == "ro") {
		return RomanRegionOverrides;
	}
	return DefaultRegion;
}
